import { all, takeEvery, put, fork } from "redux-saga/effects";

//import axios from "axios";
import axios from "./initialize";

import { Modal } from "antd";
import {
  ExclamationCircleOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import {
  ADD_LICENSE_PURCHASE_PROPERTY,
  DELETE_LICENSE_PURCHASE_PROPERTIY,
  GET_LICENSE_PURCHASE_PROPERTIES,
  UPDATE_LICENSE_PURCHASE_PROPERTIY,
  SET_ADD_EDIT,
  ADD_LICENSE_PRICING,
  GET_LICENSE_PRCING_LIST,
  DELETE_LICENSE_PRICING,
  UPDATE_LICENSE_PRICING,
  ADD_LICENSE_PRICING_VALUE,
  GET_LICENSE_PRCING_VALUE_LIST,
  DELETE_LICENSE_PRICING_VALUE,
  UPDATE_LICENSE_PRICING_VALUE,
  GET_LICENSE_PRCING_VALUE_LISTS
} from "redux/constants/licensePricing";

import {
  licensePurchaseProperties,
  showlicensePurchasePropertiesMessage,
  showAppMessage,   
  setAddEdit,
  licensePricingList,
  licensePricingValueList
} from "redux/actions/licensePricing";
import { API_BASE_DEVELOPER_APP, API_BASE_URL, APP_PREFIX_PATH, AUTH_PREFIX_PATH, MANAGE_PREPIX_PATH, USERS_PREPIX_PATH,API,VERSION } from "configs/AppConfig";
import { AUTH_TOKEN } from "../constants/Auth";
import { t } from "i18next";
import { PATH_VARIABLE } from "constants/ApiConstant";
import { appInstaneData } from "redux/actions/appInstance";

export function* saveLicensePurchaseProperties() {
  yield takeEvery(ADD_LICENSE_PURCHASE_PROPERTY, function* ({ payload }) {
    try {
      const accountId = localStorage.getItem("accountId");
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.post(
        `${API_BASE_DEVELOPER_APP}/developerApp/licensePurchaseProperties`,
        payload,
        config
      );
      if (res.status === 200) {
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/licensePurchaseProperties?appId=${
            payload?.appId
          }&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: t("impaqx.adminApp.licensePurchasePropertyCreateSuccessMessage"),
            icon: <CheckCircleFilled />,
            okText: t("impaqx.adminApp.close"),
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
        }
        yield put(licensePurchaseProperties(response.data));
        yield put(setAddEdit(false));
      }
    } catch (err) {
      console.log(err);
      yield put(showlicensePurchasePropertiesMessage(err?.response?.data));
    }
  });
}

export function* getLicensePurchaseProperties() {
  yield takeEvery(GET_LICENSE_PURCHASE_PROPERTIES, function* ({ payload }) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/licensePurchaseProperties?appId=${
          payload?.appId
        }&query=${payload?.query}&sortfield=${
          payload?.sorter?.field
        }&sortorder=${payload?.sorter?.order}&page=${
          payload?.pagination?.current - 1
        }&size=${payload?.pagination?.pageSize}`,
        config
      );
      if (res.status === 200) {
        yield put(licensePurchaseProperties(res.data));
      }
    } catch (err) {
      console.log(err);
      yield put(showlicensePurchasePropertiesMessage(err?.response?.data));
    }
  });
}


export function* deleteLicensePurchaseProperties() {
  yield takeEvery(DELETE_LICENSE_PURCHASE_PROPERTIY, function* ({ payload }) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.delete(
        `${API_BASE_DEVELOPER_APP}/developerApp/licensePurchaseProperties/${payload.id}`,
        config
      );
      if (res.status === 200) {
        //yield put(showAccountMessage(res));
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/licensePurchaseProperties?appId=${
            payload?.appId
          }&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: `${payload.licenseProperty}  ${t("impaqx.adminApp.deleteLicensePurchasePropertiesMessage")}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
          yield put(licensePurchaseProperties(response.data));
        }
      }
    } catch (error) {
      console.log(error);
      yield put(showlicensePurchasePropertiesMessage(error?.response?.data));
    }
  });
}

export function* updateLicensePurchaseProperties() {
  yield takeEvery(UPDATE_LICENSE_PURCHASE_PROPERTIY, function* ({ payload }) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.put(
        `${API_BASE_DEVELOPER_APP}/developerApp/licensePurchaseProperties/${payload.id}`,
        payload,
        config
      );
      if (res.status === 200) {
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/licensePurchaseProperties?appId=${
            payload?.appId
          }&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: `${payload.licenseProperty}  ${t("impaqx.adminApp.updateLicensePurchasePropertiesMessage")}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
          yield put(licensePurchaseProperties(response.data));
          yield put(setAddEdit(false));
        }
      }
    } catch (error) {
      console.log(error);
      yield put(showlicensePurchasePropertiesMessage(error?.response?.data));
    }
  });
}

export function* addLicensePricing() {
  yield takeEvery(ADD_LICENSE_PRICING, function* ({ payload }) {
    try {
      const accountId = localStorage.getItem("accountId");
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.post(
        `${API_BASE_DEVELOPER_APP}/developerApp/licensePricing`,
        payload,
        config
      );
      if (res.status === 200) {
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/licensePricing?appId=${
            payload?.appId
          }&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: t("impaqx.adminApp.licensePricingCreateSuccessMessage"),
            icon: <CheckCircleFilled />,
            okText: t("impaqx.adminApp.close"),
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
        }
        yield put(licensePricingList(response.data));
        yield put(setAddEdit(false));
      }
    } catch (err) {
      console.log(err);
      yield put(showlicensePurchasePropertiesMessage(err?.response?.data));
    }
  });
}

export function* getLicensePricingList() {
  yield takeEvery(GET_LICENSE_PRCING_LIST, function* ({ payload }) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/licensePricing?appId=${
          payload?.appId
        }&query=${payload?.query}&sortfield=${
          payload?.sorter?.field
        }&sortorder=${payload?.sorter?.order}&page=${
          payload?.pagination?.current - 1
        }&size=${payload?.pagination?.pageSize}`,
        config
      );
      if (res.status === 200) {
        yield put(licensePricingList(res.data));
      }
    } catch (err) {
      console.log(err);
      yield put(showlicensePurchasePropertiesMessage(err?.response?.data));
    }
  });
}


export function* deleteLicensePrcing() {
  yield takeEvery(DELETE_LICENSE_PRICING, function* ({ payload }) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.delete(
        `${API_BASE_DEVELOPER_APP}/developerApp/licensePricing/${payload.id}`,
        config
      );
      if (res.status === 200) {
        //yield put(showAccountMessage(res));
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/licensePricing?appId=${
            payload?.appId
          }&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: `${payload.name}  ${t("impaqx.adminApp.deleteLicensePricingMessage")}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
          yield put(licensePricingList(response.data));
        }
      }
    } catch (error) {
      console.log(error);
      yield put(showlicensePurchasePropertiesMessage(error?.response?.data));
    }
  });
}

export function* updateLicensePricing() {
  yield takeEvery(UPDATE_LICENSE_PRICING, function* ({ payload }) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.put(
        `${API_BASE_DEVELOPER_APP}/developerApp/licensePricing/${payload.id}`,
        payload,
        config
      );
      if (res.status === 200) {
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/licensePricing?appId=${
            payload?.appId
          }&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: `${payload.name}  ${t("impaqx.adminApp.updateLicensePurchasePropertiesMessage")}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
          yield put(licensePricingList(response.data));
          yield put(setAddEdit(false));
        }
      }
    } catch (error) {
      console.log(error);
      yield put(showlicensePurchasePropertiesMessage(error?.response?.data));
    }
  });
}

export function* addLicensePricingValue() {
  yield takeEvery(ADD_LICENSE_PRICING_VALUE, function* ({ payload }) {
    try {
      const accountId = localStorage.getItem("accountId");
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.post(
        `${API_BASE_DEVELOPER_APP}/developerApp/licensePricingValues`,
        payload,
        config
      );
      if (res.status === 200) {
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/licensePricingValues?licensePricingId=${
            payload?.licensePricingId
          }&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: t("impaqx.adminApp.licensePricingValueCreateSuccessMessage"),
            icon: <CheckCircleFilled />,
            okText: t("impaqx.adminApp.close"),
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
        }
        yield put(licensePricingValueList(response.data));
        yield put(setAddEdit(false));
      }
    } catch (err) {
      console.log(err);
      yield put(showlicensePurchasePropertiesMessage(err?.response?.data));
    }
  });
}

export function* getLicensePricingValueList() {
  yield takeEvery(GET_LICENSE_PRCING_VALUE_LIST, function* ({ payload }) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/licensePricingValues?licensePricingId=${
          payload?.licensePricingId
        }&query=${payload?.query}&sortfield=${
          payload?.sorter?.field
        }&sortorder=${payload?.sorter?.order}&page=${
          payload?.pagination?.current - 1
        }&size=${payload?.pagination?.pageSize}`,
        config
      );
      if (res.status === 200) {
        yield put(licensePricingValueList(res.data));
      }
    } catch (err) {
      console.log(err);
      yield put(showlicensePurchasePropertiesMessage(err?.response?.data));
    }
  });
}

export function* getLicensePricingValueLists() {
  yield takeEvery(GET_LICENSE_PRCING_VALUE_LISTS, function* ({ payload }) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/licensePricingValuesList?licensePricingId=${
          payload?.licensePricingId
        }&query=${payload?.query}&sortfield=${
          payload?.sorter?.field
        }&sortorder=${payload?.sorter?.order}&page=${
          payload?.pagination?.current - 1
        }&size=${payload?.pagination?.pageSize}`,
        config
      );
      if (res.status === 200) {
        yield put(licensePricingValueList(res.data));
      }
    } catch (err) {
      console.log(err);
      yield put(showlicensePurchasePropertiesMessage(err?.response?.data));
    }
  });
}


export function* deleteLicensePrcingValue() {
  yield takeEvery(DELETE_LICENSE_PRICING_VALUE, function* ({ payload }) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.delete(
        `${API_BASE_DEVELOPER_APP}/developerApp/licensePricingValues/${payload.id}`,
        config
      );
      if (res.status === 200) {
        //yield put(showAccountMessage(res));
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/licensePricingValues?licensePricingId=${
            payload?.licensePricingId
          }&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: `${t("impaqx.adminApp.deleteLicensePricingValuesMessage")}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
          yield put(licensePricingValueList(response.data));
        }
      }
    } catch (error) {
      console.log(error);
      yield put(showlicensePurchasePropertiesMessage(error?.response?.data));
    }
  });
}

export function* updateLicensePricingValue() {
  yield takeEvery(UPDATE_LICENSE_PRICING_VALUE, function* ({ payload }) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.put(
        `${API_BASE_DEVELOPER_APP}/developerApp/licensePricingValues/${payload.id}`,
        payload,
        config
      );
      if (res.status === 200) {
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/licensePricingValues?licensePricingId=${
            payload?.licensePricingId
          }&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: `${t("impaqx.adminApp.updateLicensePricingValueMessage")}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
          yield put(licensePricingValueList(response.data));
          yield put(setAddEdit(false));
        }
      }
    } catch (error) {
      console.log(error);
      yield put(showlicensePurchasePropertiesMessage(error?.response?.data));
    }
  });
}


export default function* rootSaga() {
  yield all([
    fork(getLicensePurchaseProperties),
    fork(saveLicensePurchaseProperties),
    fork(deleteLicensePurchaseProperties),
    fork(updateLicensePurchaseProperties),
    fork(getLicensePricingList),
    fork(addLicensePricing),
    fork(deleteLicensePrcing),
    fork(updateLicensePricing),
    fork(addLicensePricingValue),
    fork(getLicensePricingValueList),
    fork(getLicensePricingValueLists),
    fork(deleteLicensePrcingValue),
    fork(updateLicensePricingValue)
  ]);
}
